<div class="email-otp-instructions row text-center">
  <span>{{ 'login.v2.email_otp_instructions' | translate }}</span>
</div>
<form class="email-otp-form"
      [class.submitted]="submitted"
      [formGroup]="form"
      (ngSubmit)="onSubmit()">
  <div class="form-group label-static"
       [ngClass]="{'is-focused': $any(input)?.isFocused, 'has-error': formErrors.error }">
    <label class="control-label">
      <span>{{ 'generic.password' | translate }}</span>
    </label>
    <input class="email-otp-input form-control"
           type="password"
           formControlName="password"
           #input
    />
  </div>
  @if (formErrors.error) {
    <app-input-errors
        translationKey="errors.login"
        [errorsForField]="formErrors"/>
  }
  <div class="send-password-wrapper">
    @if (isSendingPassword) {
      <span>{{ 'generic.sending_password' | translate }}</span>
    }
    @if (passwordSendComplete) {
      @if (passwordSendSuccess) {
        <span class="email-otp-success">
          {{ 'generic.password_sent_status' | translate }}
        </span>
      }
      @if (!passwordSendSuccess) {
        <span class="email-otp-failure">
          {{ 'members.send_password.error_message' | translate }}
        </span>
      }
      <a class="email-otp-resend underline" (click)="sendPassword()">
        <span>{{ 'generic.resend_password_click_here' | translate }}</span>
      </a>
    }
  </div>
  <button type="submit" class="email-otp-submit btn btn-raised btn-block btn-primary">
    <span>{{ 'generic.button_next' | translate }}</span>
  </button>
</form>
